/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_Reference_MaterialInputs */

const en_ai_reference_material = /** @type {(inputs: Ai_Reference_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Reference`)
};

const id_ai_reference_material = /** @type {(inputs: Ai_Reference_MaterialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Referensi AI`)
};

/** @type {(inputs: Ai_Reference_MaterialInputs) => LocalizedString} */
const es_ai_reference_material = en_ai_reference_material;

/** @type {(inputs: Ai_Reference_MaterialInputs) => LocalizedString} */
const fr_ai_reference_material = en_ai_reference_material;

/** @type {(inputs: Ai_Reference_MaterialInputs) => LocalizedString} */
const de_ai_reference_material = en_ai_reference_material;

/** @type {(inputs: Ai_Reference_MaterialInputs) => LocalizedString} */
const ja_ai_reference_material = en_ai_reference_material;

/** @type {(inputs: Ai_Reference_MaterialInputs) => LocalizedString} */
const zh_ai_reference_material = en_ai_reference_material;

/** @type {(inputs: Ai_Reference_MaterialInputs) => LocalizedString} */
const ar_ai_reference_material = en_ai_reference_material;

/** @type {(inputs: Ai_Reference_MaterialInputs) => LocalizedString} */
const it_ai_reference_material = en_ai_reference_material;

/** @type {(inputs: Ai_Reference_MaterialInputs) => LocalizedString} */
const ru_ai_reference_material = en_ai_reference_material;

/** @type {(inputs: Ai_Reference_MaterialInputs) => LocalizedString} */
const pt_ai_reference_material = en_ai_reference_material;

/** @type {(inputs: Ai_Reference_MaterialInputs) => LocalizedString} */
const ko_ai_reference_material = en_ai_reference_material;

/**
* | output |
* | --- |
* | "AI Reference" |
*
* @param {Ai_Reference_MaterialInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const ai_reference_material = /** @type {((inputs?: Ai_Reference_MaterialInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Reference_MaterialInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ai_reference_material(inputs)
	if (locale === "es") return es_ai_reference_material(inputs)
	if (locale === "fr") return fr_ai_reference_material(inputs)
	if (locale === "de") return de_ai_reference_material(inputs)
	if (locale === "ja") return ja_ai_reference_material(inputs)
	if (locale === "zh") return zh_ai_reference_material(inputs)
	if (locale === "ar") return ar_ai_reference_material(inputs)
	if (locale === "id") return id_ai_reference_material(inputs)
	if (locale === "it") return it_ai_reference_material(inputs)
	if (locale === "ru") return ru_ai_reference_material(inputs)
	if (locale === "pt") return pt_ai_reference_material(inputs)
	return ko_ai_reference_material(inputs)
});